import React from 'react';
import { func, array } from 'prop-types';
import styled from 'styled-components';
import Avatar from '~/views/common/Avatar';

import { Icon, Button } from 'semantic-ui-react';

const Container = styled.div`
    display: flex;
    padding: 10px 0px;
    flex-direction: column;
    flex-wrap: wrap;
`;

const WrapperItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 600px;
    padding: 10px;
    border: 1px solid rgba(222, 222, 222, 1);
    margin-bottom: 5px;
    border-radius: 4px;
    align-items: center;
`;

const WrapperName = styled.div`
    display: flex;
    align-items: center;
`;

const Name = styled.span`
    font-size: 15px;
`;

const AffiliateList = ({
    items,
    onHandlerDelete,
}) => (
    <Container>
        {
            items.length > 0 ? (
                items.map((e) => {
                    const {
                        name,
                        id,
                        logo,
                    } = e;
                    return (
                        <WrapperItem key={id}>
                            <WrapperName>
                                <Avatar src={logo} />
                                <Name>{ name }</Name>
                            </WrapperName>
                            <Button type="button" icon onClick={() => onHandlerDelete(e)}>
                                <Icon name="delete" />
                            </Button>
                        </WrapperItem>
                    );
                })
            ) : null
        }
    </Container>
);


AffiliateList.propTypes = {
    items: array,
    onHandlerDelete: func,
};

AffiliateList.defaultProps = {
    items: [],
    onHandlerDelete: () => {},
};

export default AffiliateList;
